import { FilterOptionValue } from 'src/types';

export const DELIVERY_FILTER_VISIBILITY_NAME = 'deliveryFilter';

export type FilterEventCategory = 'Filters' | 'Quick filters';

export interface CustomFilterEvent {
  event: 'custom_event';
  event_category: FilterEventCategory;
  event_action: string;
  event_label: FilterOptionValue;
}

export interface DeliveryQuickFilterImpression {
  event: 'custom_event';
  event_category: 'Quick filters';
  event_action: 'quick filter impression';
  event_label: 'delivery';
}

export interface DeliveryFilterImpression {
  event: 'custom_event';
  event_category: 'Filters';
  event_action: 'filter impression';
  event_label: 'delivery';
}
